import React from "react";
import { FinishCookingOrderModel } from "../models/finish_cooking_order_model";

interface Props {
    model: FinishCookingOrderModel;
    onTick: (args: { orderId: number; isNotDone: boolean }) => void;
}

export default class FinishCookingOrderCellWidget extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            <>
                <div className="rounded-md bg-white border border-black p-4 inline-block m-2">
                    <p className="text-sm font-medium mb-2">
                        <span className="font-bold">Order Id:</span>{" "}
                        {this.props.model.orderId}
                    </p>
                    <p className="text-sm font-medium mb-2">
                        <span className="font-bold">Platform Id:</span>{" "}
                        {this.props.model.platformId}
                    </p>
                    <p className="text-sm font-medium mb-2">
                        <span className="font-bold">Pengiriman:</span>{" "}
                        {this.props.model.deliveryMethod}
                    </p>
                    <p className="text-sm font-medium mb-2">
                        <span className="font-bold">Nama Customer:</span>{" "}
                        {this.props.model.customerName}
                    </p>
                    <p className="text-sm font-medium mb-4">
                        <span className="font-bold">Outlet:</span>{" "}
                        {this.props.model.outlet}
                    </p>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 mx-1 rounded hover:bg-blue-600"
                        onClick={() => {
                            this.props.onTick({
                                orderId: this.props.model.id,
                                isNotDone: false,
                            });
                        }}
                    >
                        Tick
                    </button>
                    <button
                        className="bg-blue-500 text-white px-4 py-2 mx-1 rounded hover:bg-blue-600"
                        onClick={() => {
                            this.props.onTick({
                                orderId: this.props.model.id,
                                isNotDone: true,
                            });
                        }}
                    >
                        Not Done
                    </button>
                </div>
            </>
        );
    }
}
